import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchGeneralServicePackage } from "../../services/publicCrmApi";

/**
 * Single source of truth for the active "General Service" CRM package on
 * the /carservice landing page. Fetched once on mount; consumers (pricing
 * tiers, inclusions grid, lookup widget, booking modal) read from this
 * context. If the API is unreachable, `pkg` stays `null` and consumers
 * silently fall back to their bundled static data — the LP keeps working.
 */
const CarServicePackageContext = createContext({
  pkg: null,
  loading: true,
  error: null,
});

export const CarServicePackageProvider = ({ children }) => {
  const [pkg, setPkg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const found = await fetchGeneralServicePackage();
        if (!cancelled) setPkg(found || null);
      } catch (e) {
        if (!cancelled) setError(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <CarServicePackageContext.Provider value={{ pkg, loading, error }}>
      {children}
    </CarServicePackageContext.Provider>
  );
};

export const useCarServicePackage = () => useContext(CarServicePackageContext);
